import { c as create$3, a as create$6 } from './form.js';
import { a as addressSchema } from './business-address-schema.js';
import { i as identityNameValidation, I as identityTitleValidation, t as emailValidation, u as phoneValidation, J as dobValidation, K as ssnValidation } from './schema-validations.js';

const identitySchema = (role, allowOptionalFields) => {
    const schema = create$3({
        name: identityNameValidation.required(`Enter ${role} name`),
        title: identityTitleValidation.required(`Enter ${role} title`),
        email: emailValidation.required(`Enter ${role} email`),
        phone: phoneValidation.required('Enter phone number'),
        dob_full: dobValidation(role).required('Enter date of birth'),
        ssn_last4: create$6().nullable(),
        identification_number: ssnValidation,
        address: addressSchema(allowOptionalFields),
    });
    const easySchema = create$3({
        name: identityNameValidation.required(`Enter ${role} name`),
        title: identityTitleValidation.nullable(),
        email: emailValidation.nullable(),
        phone: phoneValidation.nullable(),
        dob_full: dobValidation(role).nullable(),
        ssn_last4: create$6().nullable(),
        identification_number: ssnValidation.nullable(),
        address: addressSchema(allowOptionalFields),
    });
    return allowOptionalFields ? easySchema : schema;
};

export { identitySchema as i };
